import { Module } from '../plugins/_application'
import Swiper from 'swiper/bundle'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'

var $ = jQuery

export default class MapPinSlider extends Module {

  ready (app) {
    const sliderWrappers = document.querySelectorAll('.mtt-maps-with-pins__pin-tooltip')
    const pins = document.querySelectorAll('.mtt-maps-with-pins__pin')

    if (sliderWrappers.length) {
      for (let i = 0; i < sliderWrappers.length; i++) {
        const sliderWrapper = sliderWrappers[i]
        new PinSlider(sliderWrapper)
      }
    }

    if (pins.length) {
      for (let i = 0; i < pins.length; i++) {
        const pin = pins[i]
        new PinTooltip(pin)
      }
    }
  }
}

class PinTooltip {
  constructor (pin) {
    this.pin = pin

    if (pin.classList.contains('has-link')) {
      return
    }

    this.tooltip = this.pin.querySelector('.mtt-maps-with-pins__pin-tooltip')
    this.closeButton = this.pin.querySelector('.mtt-maps-with-pins__pin-slide-close')
    this.swiper = this.pin.querySelector('.swiper')
    this.addTippy()
  }

  addTippy () {
    const tooltip = this.tooltip
    const swiper = this.swiper.swiper

    const tip = tippy(this.pin, {
      content: this.tooltip,
      allowHTML: true,
      trigger: 'click',
      maxWidth: 'none',
      arrow: false,
      interactive: true,
      zIndex: 8,
      onMount (instance) {
        swiper.update()
        tooltip.removeAttribute('style')
      }
    })

    this.closeButton.addEventListener('click', () => {
      tip.hide()
    })
  }
}

class PinSlider {
  constructor (sliderWrapper) {
    this.sliderWrapper = sliderWrapper
    this.slider = this.sliderWrapper.querySelector('.swiper')
    this.addSlider()
  }

  addSlider () {
    const swiper = new Swiper(this.slider, {
      slidesPerView: 1.,
      lazy: true,
      watchOverflow: true,
      pagination: {
        el: this.sliderWrapper.querySelector('.mtt-maps-with-pins__pin-slide-pagination'),
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: this.sliderWrapper.querySelector('.mtt-maps-with-pins__pin-button--next'),
        prevEl: this.sliderWrapper.querySelector('.mtt-maps-with-pins__pin-button--prev'),
      },
    })
  }
}